import React, { FC, Fragment } from 'react'
import './index.css'
import { Button } from 'antd';

interface Props {
    title?: string,
    backable?: boolean,
    children?: React.ReactNode,
}

interface BackPros {
    backable: boolean,
}

const Back: FC<BackPros> = (props) => {
    const { backable } = props
    return (backable ? <Button type='link' size='small' onClick={() => { window.history.back() }}> 返回</Button> : <Fragment />)
}

const Page: FC<Props> = (props) => {
    const { title, children, backable = false } = props
    return (
        <div className='page'>
            {title ? <div className='page-header'><Back backable={backable} />{title}</div> : <Back backable={backable} />}
            <div className='page-content'>{children}</div>
        </div>)
}

export default Page